import React, { useState } from "react"
import { motion } from 'framer-motion'
import { SiKashflow } from "react-icons/si";
import { MdOutlineViewInAr } from "react-icons/md";
import { FaShippingFast } from "react-icons/fa";
import API from "../Common/API";
import { setBuyNowProducts } from "../Store/Auth/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const OrderCard = ({ list, status }) => {

    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()

    const buyItAgain = (value) => {
        setLoading(true)
        try {
            API.get(`/products/getProductById/${value._id}`).then((prodRes) => {
                if (prodRes.status === 200) {
                    let product = prodRes.data.data
                    product.fromWishList = false
                    product.fromCart = false
                    dispatch(setBuyNowProducts([product]))
                    localStorage.setItem('buyNowProducts', JSON.stringify(product))
                    history.push('/product/checkOut')
                    setLoading(false)
                }
            })
        } catch (err) {
            throw err
        }
    }

    const viewItem = (value) => {
        history.push(`/product/${value._id}/view`)
    }

    const reviewItem = (value) => {
        history.push(`/product/${value._id}/review`)
    }

    return (
        <>
            {
                loading ? <motion.div className="bg-slate-200 flex flex-col justify-center items-center bg-opacity-20 min-h-screen w-full">
                    <motion.div className="text-black text-xl font-bold">Loading ....</motion.div>
                </motion.div> : list.map((l) => {
                    return (
                        <motion.div className="w-full drop-shadow-lg bg-slate-200 my-2 rounded-xl relative flex flex-col">
                            <motion.div className="w-full h-28 px-2 py-5 items-center justify-between flex flex-row bg-amber-50">
                                <motion.div className="w-96 flex flex-row justify-between">
                                    <motion.div className="flex flex-col items-center">
                                        <motion.div className="text-xl font-bold">
                                            Order Placed
                                        </motion.div>
                                        <motion.div className="text-md font-bold">
                                            {l.orderPlacedDate}
                                        </motion.div>
                                    </motion.div>
                                    <motion.div className="flex flex-col items-center">
                                        <motion.div className="text-xl font-bold">
                                            Total
                                        </motion.div>
                                        <motion.div className="text-md font-bold">
                                            {l.totalAmount / 100}
                                        </motion.div>
                                    </motion.div>
                                    <motion.div className="flex flex-col items-center">
                                        <motion.div className="text-xl font-bold">
                                            Ship To
                                        </motion.div>
                                        <motion.div className="text-md font-bold">
                                            {l.name}
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                                <motion.div className="flex flex-col w-96">
                                    <motion.div className="text-xl font-bold">
                                        Order #{l.orderId}
                                    </motion.div>
                                </motion.div>
                            </motion.div>
                            <motion.div className="flex flex-col">
                                {
                                    l.invoices.map((inv) => {
                                        return (
                                            <motion.div className="flex px-2 py-2 flex-row w-full h-full items-center">
                                                <img src={inv.images[0].imageUrl} height={100} width={100} />
                                                <motion.div className="flex flex-col px-2 py-2 justify-evenly">
                                                    <motion.div className="text-xl font-bold my-2">
                                                        {inv.productId.productName}&nbsp;/&nbsp;{inv.productId.brandName}&nbsp;/&nbsp;{inv.productId.modelName}
                                                    </motion.div>
                                                    <motion.div className="flex flex-row justify-between my-2">
                                                        <motion.div className="flex flex-row my-2">
                                                            <motion.div className="px-2 py-2 flex flex-row items-center cursor-pointer bg-black text-white rounded-md mx-2" onClick={() => buyItAgain(inv.productId)}>
                                                                <SiKashflow className="mx-2" />Buy it again
                                                            </motion.div>
                                                            <motion.div className="px-2 flex flex-row items-center py-2 cursor-pointer bg-white drop-shadow-lg text-black rounded-md mx-2" onClick={() => viewItem(inv.productId)}>
                                                                <MdOutlineViewInAr className="mx-2" /> View your item
                                                            </motion.div>
                                                            <motion.div className="px-2 flex flex-row items-center py-2 cursor-pointer text-black font-bold rounded-md mx-2" onClick={() => viewItem(inv.productId)}>
                                                                ({status.filter((x) => x.orderStatusId === inv.orderStatus)[0].orderStatus})
                                                            </motion.div>
                                                        </motion.div>
                                                        {(status.filter((x) => x.orderStatusId === inv.orderStatus)[0].orderStatus) === 'Delivered' && <motion.div className="flex flex-row my-2">
                                                            <motion.div className="px-2 flex flex-row items-center py-2 cursor-pointer bg-white drop-shadow-lg text-black rounded-md mx-2" onClick={() => reviewItem(inv.productId)}>
                                                                Write your review
                                                            </motion.div></motion.div>}
                                                    </motion.div>
                                                </motion.div>
                                            </motion.div>
                                        )
                                    })
                                }
                                {/* <motion.div className="px-2 py-2 my-2 flex flex-row items-center cursor-pointer bg-white drop-shadow-lg text-black rounded-md mx-2">
                                    <FaShippingFast className="mx-2" />Track Package
                                </motion.div> */}
                            </motion.div>
                        </motion.div>
                    )
                })
            }
        </>
    )
}

export default OrderCard